/** @file Starts the keyboard listener and registers the shell's own global bindings with their handlers. */
import type { KeyTarget, ListenOptions } from '@pose2d/shortcuts/keyTarget';
import { listen } from '@pose2d/shortcuts/listen';
import type { Platform } from '@pose2d/shortcuts/types';
import { bindings } from './bindings';
import { registerEffective } from './registerEffective';

function registerShell(handlers: Record<string, () => void>, stop: () => void, platform?: Platform): () => void {
  try {
    return registerEffective('global', bindings, handlers, platform);
  } catch (error) {
    stop();
    throw error;
  }
}

/** Registers only the shell table (`bindings.ts`); panels and tools register theirs when they mount (Wave 3). */
export function installShortcuts(target: KeyTarget, handlers: Record<string, () => void>, options: ListenOptions = {}): () => void {
  const stop = listen(target, options);
  const unregister = registerShell(handlers, stop, options.platform);
  return () => {
    unregister();
    stop();
  };
}
